import Vue from 'vue'
import VueRouter from 'vue-router'
import ClearPage from '@/views/ClearPage.vue'
import ClearView from '@/views/ClearView.vue'
import Login from '@/components/user/login/Login.vue'
import Home from '@/views/home/Home.vue'
import Clients from '@/views/clients/Clients.vue'
import Reports from '@/views/reports/Reports.vue'
import ClientList from '@/components/client/list/ClientList.vue'
import ClientReport from '@/components/client/report/ClientReport.vue'
import ClientEdit from '@/components/client/edit/ClientEdit.vue'
import ContactList from '@/components/contact/list/ContactList.vue'
import MaterialCategoryList from '@/components/material/category/list/MaterialCategoryList.vue';
import MaterialGroupList from '@/components/material/group/list/MaterialGroupList.vue';
import MaterialRatesList from '@/components/material/rateslist/MaterialRatesList.vue';
import UserList from '@/components/user/list/UserList.vue';
import ClientBills from '@/components/client/bills/list/ClientBills.vue';
import InfoList from '@/components/info/list/InfoList.vue';
import MaterialLog from '@/components/material/log/MaterialLog.vue'
import UserEdit from '@/components/user/edit/UserEdit.vue'
import UserResetPassword from '@/components/user/resetpassword/UserResetPassword.vue'
import UserLog from '@/components/user/log/UserLog.vue'
import BankList from '@/components/bank/list/BankList.vue'
import ProductServiceCategoryList from '@/components/configs/productservicecategory/list/ProductServiceCategoryList.vue'
import ReportConfigs from '@/components/reports/config/ReportConfigs.vue'
import ConfigConstantsList from '@/components/configs/constants/list/ConfigConstantsList.vue'
import ConfigEmailsList from '@/components/configs/emails/list/ConfigEmailsList.vue'
import SeminarEdit from '@/components/seminar/edit/SeminarEdit.vue'
import ScheduledTasksList from '@/components/admin/scheduletasks/list/ScheduledTasksList.vue';
import DrnTemplateslist from '@/components/configs/drn/templates/list/DrnTemplatesList.vue';
import RegenTemplatesList from '@/components/configs/regen/templates/list/RegenTemplatesList.vue';
import AxaptBillsList from '@/components/axaptbills/list/AxaptBillsList.vue'
import LogGeneral from '@/components/log/general/LogGeneral.vue'
import AdminSetup from '@/components/admin/setup/AdminSetup.vue'
import EeiregList from '@/components/eeireg/list/EeiregList.vue'
import TranslationsList from '@/components/translations/list/TranslationsList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'menu.user.login',
    component: Login,
    meta: { public: true, noSession: true }
  },
  {
    path: '/reset-password/:apiId?',
    name: 'menu.user.reset-password',
    component: UserResetPassword,
    meta: { public: true, noSession: true }
  },
  {
    path: '/home',
    name: 'menu.home',
    component: Home,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: null }
  },
  {
    path: '/client-reports',
    title: 'menu.reports.simple',
    component: ClearView,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-reports', 'view-client-frontend'], hasClientOrManager: true },
    children: [
      {
        path: '',
        redirect: { name: 'menu.reports.simple' }
      },
      {
        path: 'list',
        name: 'menu.reports.simple',
        component: Reports,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-client-frontend', 'view-reports'], parentPath: '/client-reports', hasClientOrManager: true }
      },
      {
        path: 'eeireg-eei',
        name: 'menu.reports.eeireg.eei',
        component: EeiregList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-eeireg'], parentPath: '/client-reports', reqpath: 'ELECTRO' }
      },
      {
        path: 'eeireg-vkp',
        name: 'menu.reports.eeireg.vkp',
        component: EeiregList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-eeireg'], parentPath: '/client-reports', reqpath: 'VKP' }
      }
    ]
  },
  {
    path: '/bills',
    component: ClearPage,
    title: 'menu.clients.bills',
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-reports', 'view-client-frontend'], hideChildrenIfOne: true, hasClientOrManager: true },
    children: [
      {
        path: '',
        redirect: { name: 'menu.clients.bills' }
      },
      {
        path: 'list',
        name: 'menu.clients.bills',
        component: ClientBills,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-client-frontend', 'view-reports'], parentPath: '/bills', hasClientOrManager: true }
      },
      {
        path: 'axapt-bills',
        name: 'menu.admin.axaptbills',
        component: AxaptBillsList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-axbills'], parentPath: '/bills', isConfigPage: true }
      }
    ]
  },
  {
    path: '/myclient',
    title: 'menu.clients.mydata',
    component: Clients,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-client-frontend'], hasClientOrManager: true },
    children: [
      {
        path: '',
        name: 'menu.clients.mydata',
        component: ClientEdit,
        meta: { public: false, noSession: false, isMenuItem: false, permissions: ['view-client-frontend'], hasClientOrManager: true }
      }
    ]
  },
  {
    path: '/contacts',
    name: 'menu.contacts',
    component: ContactList,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: null }
  },
  {
    path: '/reports',
    title: 'menu.reports.summary',
    component: Reports,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-reports'] },
    children: [
      {
        path: '',
        redirect: { name: 'menu.reports.materials' }
      },
      {
        path: 'material',
        name: 'menu.reports.materials',
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-reports'], parentPath: '/reports' }
      },
      {
        path: 'regen-reports',
        name: 'menu.reports.regen',
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-reports'], parentPath: '/reports' }
      },
      {
        path: 'drn-reports',
        name: 'menu.reports.drn',
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-reports'], parentPath: '/reports' }
      },
      {
        path: 'bill-reports',
        name: 'menu.reports.bills',
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-reports'], parentPath: '/reports' }
      },
      {
        path: 'clients',
        name: 'menu.reports.clients',
        meta: { public: false, noSession: false, isMenuItem: false, permissions: ['view-reports'], parentPath: '/reports' }
      }
    ]
  },
  {
    path: '/client',
    title: 'menu.clients.title',
    component: Clients,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-clients'] },
    children: [
      {
        path: '',
        name: 'menu.clients.title',
        component: ClientList,
        meta: { public: false, noSession: false, isMenuItem: false, permissions: ['view-clients'] }
      },
      {
        path: ':clientApiId',
        component: ClearView,
        meta: { public: false, noSession: false, isMenuItem: false, permissions: ['view-clients'] },
        children: [
          {
            path: '',
            redirect: { name: 'menu.client.edit' }
          },
          {
            path: 'edit',
            name: 'menu.client.edit',
            component: ClientEdit,
            meta: { public: false, noSession: false, isMenuItem: false, permissions: ['view-clients'], clientPermission: null }
          },
          {
            path: 'report/:reportCode/:datePeriodCode',
            name: 'menu.client.report',
            component: ClientReport,
            meta: { public: false, noSession: false, isMenuItem: false, permissions: ['view-clients'], clientPermission: null }
          }
        ]
      }
    ]
  },
  {
    path: '/material',
    title: 'menu.material.title',
    component: ClearPage,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'] },
    children: [
      {
        path: '',
        redirect: { name: 'menu.material.list' }
      },
      {
        path: 'list',
        name: 'menu.material.list',
        component: MaterialRatesList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/material', isConfigPage: true }
      },
      {
        path: 'categories',
        name: 'menu.material.categories',
        component: MaterialCategoryList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/material', isConfigPage: true }
      },
      {
        path: 'groups',
        name: 'menu.material.groups',
        component: MaterialGroupList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/material', isConfigPage: true }
      },
      {
        path: 'log',
        name: 'menu.material.log',
        component: MaterialLog,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/material' }
      }
    ]
  },
  {
    path: '/user',
    title: 'menu.user.title',
    component: ClearPage,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'] },
    children: [
      {
        path: '',
        redirect: { name: 'menu.user.list' }
      },
      {
        path: 'list',
        name: 'menu.user.list',
        component: UserList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/user' }
      },
      {
        path: 'log',
        name: 'menu.user.log',
        component: UserLog,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/user' }
      },
      {
        path: 'my-edit',
        name: 'menu.user.my-edit',
        component: UserEdit,
        meta: { public: false, noSession: false, isMenuItem: false, permissions: null }
      }
    ]
  },
  {
    path: '/info',
    title: 'menu.info.title',
    component: ClearPage,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: null },
    children: [
      {
        path: '',
        redirect: { name: 'menu.info.news' }
      },
      {
        path: 'news',
        name: 'menu.info.news',
        component: InfoList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: null, parentPath: '/info', reqpath: 'news' }
      },
      {
        path: 'seminars',
        title: 'menu.info.seminars',
        component: ClearView,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: null, parentPath: '/info', reqpath: 'seminars' },
        children: [
          {
            path: '',
            name: 'menu.info.seminars.list',
            component: InfoList,
            meta: { public: false, noSession: false, isMenuItem: true, permissions: null, parentPath: '/info', reqpath: 'seminars' }
          },
          {
            path: ':seminarApiId',
            component: ClearView,
            children: [
              {
                path: 'view',
                name: 'menu.info.seminars.view',
                component: SeminarEdit,
                meta: { public: false, noSession: false, isMenuItem: false, permissions: null }
              }
            ]
          }
        ]
      },
      {
        path: 'regulations',
        name: 'menu.info.regulations',
        component: InfoList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: null, parentPath: '/info', reqpath: 'regulations' }
      }
    ]
  },
  {
    path: '/config',
    title: 'menu.config.title',
    component: ClearPage,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'] },
    children: [
      {
        path: '',
        redirect: { name: 'menu.config.emails.title' }
      },
      {
        path: 'emails',
        name: 'menu.config.emails.title',
        component: ConfigEmailsList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/config', isConfigPage: true }
      },
      {
        path: 'reports',
        name: 'menu.config.reports.title',
        component: ReportConfigs,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/config', isConfigPage: true }
      },
      {
        path: 'banks',
        name: 'menu.config.banks',
        component: BankList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/config', isConfigPage: true }
      },
      {
        path: 'drn-templates',
        name: 'menu.config.drn-templates.title',
        component: DrnTemplateslist,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/config', isConfigPage: true }
      },
      {
        path: 'product_service_categories',
        name: 'menu.config.product_service_category.title',
        component: ProductServiceCategoryList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/config', isConfigPage: true }
      },
      {
        path: 'constants',
        name: 'menu.config.constants.title',
        component: ConfigConstantsList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/config', isConfigPage: true }
      },
      {
        path: 'regen-templates',
        name: 'menu.config.regen-templates.title',
        component: RegenTemplatesList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/config', isConfigPage: true }
      }
    ]
  },
  {
    path: '/admin',
    title: 'menu.admin.title',
    component: ClearPage,
    meta: { public: false, noSession: false, isMenuItem: true, permissions: ['edit-cron', 'view-settings'] },
    children: [
      {
        path: '',
        redirect: { name: 'menu.admin.general-log' }
      },
      {
        path: 'general-log',
        name: 'menu.admin.general-log',
        component: LogGeneral,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/admin', isConfigPage: false }
      },
      {
        path: 'scheduled-tasks',
        name: 'menu.admin.scheduled-tasks',
        component: ScheduledTasksList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['edit-cron'], parentPath: '/admin', isConfigPage: true }
      },
      {
        path: 'setup',
        name: 'menu.admin.setup',
        component: AdminSetup,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/admin', isConfigPage: false }
      },
      {
        path: 'translations',
        name: 'menu.admin.translations',
        component: TranslationsList,
        meta: { public: false, noSession: false, isMenuItem: true, permissions: ['view-settings'], parentPath: '/admin', isConfigPage: false }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next({
      path: '/login'
    });
  } else {
    if (router.app.$session.exists() && to.name === 'menu.user.reset-password') {
      router.app.$session.destroy();
    }
    if (!router.app.$session.exists() && !to.meta.public) {
      next({
        path: '/login'
      });
    } else if (router.app.$session.exists() && to.meta.noSession) {
      next({
        path: '/home'
      });
    } else {
      if (!to.meta.public) {
        const permissions = router.app.$session.get('permissions');
        const clientPerm = router.app.$session.get('client_permissions');
        const clientCount = (clientPerm ? Object.keys(clientPerm).length : 0);
        const selectedClient = router.app.$session.get('selectedClientApiId');
        if (!router.app.$session.get('isSimUser') && !permissions.includes('edit-clients') && selectedClient && clientPerm[selectedClient].needUpdate) {
          if (to.name !== 'menu.home') {
            next({ path: '/home' });
          } else {
            next();
          }
        } else if (to.meta.hasClientOrManager && !(clientCount > 0 || permissions.includes('view-clients'))) {
          next({ path: '/home' });
        } else if (to.meta.permissions === null || to.meta.permissions.filter(Set.prototype.has, new Set(permissions)).length > 0) {
          next();
        } else if (to.params.clientApiId && clientPerm[to.params.clientApiId] &&
          (to.meta.clientPermission === null || clientPerm[to.params.clientApiId].includes(to.meta.clientPermission))
        ) {
          next();
        } else {
          next({ path: '/home' });
        }
      } else {
        next();
      }
    }
  }
})

export default router
